import { graphql } from '../graphql/generated';

export const DASHBOARD_DATA_QUERY = graphql(`
  query DashboardData($doctorId: ID!) {
    dashboardData(doctorId: $doctorId) {
      openRequests
      sentRequestsToday
      sentRequestsWeek
      sentRequestsMonth
      sentRequestsYear
    }

    relevantNews(doctorId: $doctorId) {
      ...NewsList_News
    }
  }
`);
